import rootReducer from '../../redux/rootReducer';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

export function wrapComponent(component, initialState = null) {
  return <Provider store={createStore(rootReducer, initialState || {})}>{component}</Provider>;
}

export function addDefaultFileValues(files, infoFields) {
  // TODO: Add test for this
  return files.map(function (file, index) {
    return {
      index: index,
      abortUpload: false,
      uploadInfo: {},
      infoFields: infoFields, // infoFields stores the original values from the backend
      originalFileData: file, // Store the original uploader File.prototype object as-is for eventual upload
      // Infofields are copied across to the values and given a default empty string
      // The title field is prefilled with the file name if no placeholder is given
      values: infoFields.map((field) => {
        return {
          field: field,
          value: field.name === 'Title' && (field.placeholder === null || field.placeholder === '') ? file.name : '',
        };
      }),
      readyToUpload:
        infoFields.filter((f) => {
          return f.required === true;
        }).length === 0,
      status: 'Needs Input',
      activateRetry: false,
      uploadProgress: 0,
      error: {},
    };
  });
}
